/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoveTogether = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m5.414 10 1.793 1.793-1.414 1.414L1.586 9l4.207-4.207 1.414 1.414L5.414 8H11v2H5.414zm12.793-5.207L22.414 9l-3.207 3.207-1.414-1.414.793-.793H13V8h5.586l-1.793-1.793 1.414-1.414zm-5.914 7.5a1 1 0 0 1 .982-.254l7 2a1 1 0 0 1 .28 1.793l-1.985 1.323 3.137 3.138-1.414 1.414-3.138-3.137-1.323 1.985a1 1 0 0 1-1.793-.28l-2-7a1 1 0 0 1 .254-.982zm2.163 2.163.911 3.19.8-1.2a1 1 0 0 1 .278-.278l1.201-.8-3.19-.912z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMoveTogether as MoveTogether };
